var countries = {
    "AF": {"name":"Afghanistan","continent_code":"AS"},
    "AX": {"name":"Aland Islands","continent_code":"EU"},
    "AL": {"name":"Albania","continent_code":"EU"},
    "DZ": {"name":"Algeria","continent_code":"AF"},
    "AS": {"name":"American Samoa","continent_code":"OC"},
    "AD": {"name":"Andorra","continent_code":"EU"},
    "AO": {"name":"Angola","continent_code":"AF"},
    "AI": {"name":"Anguilla","continent_code":"NA"},
    "AQ": {"name":"Antarctica","continent_code":"AN"},
    "AG": {"name":"Antigua and Barbuda","continent_code":"NA"},
    "AR": {"name":"Argentina","continent_code":"SA"},
    "AM": {"name":"Armenia","continent_code":"AS"},
    "AW": {"name":"Aruba","continent_code":"NA"},
    "AU": {"name":"Australia","continent_code":"OC"},
    "AT": {"name":"Austria","continent_code":"EU"},
    "AZ": {"name":"Azerbaijan","continent_code":"AS"},
    "BS": {"name":"Bahamas","continent_code":"NA"},
    "BH": {"name":"Bahrain","continent_code":"AS"},
    "BD": {"name":"Bangladesh","continent_code":"AS"},
    "BB": {"name":"Barbados","continent_code":"NA"},
    "BY": {"name":"Belarus","continent_code":"EU"},
    "BE": {"name":"Belgium","continent_code":"EU"},
    "BZ": {"name":"Belize","continent_code":"NA"},
    "BJ": {"name":"Benin","continent_code":"AF"},
    "BM": {"name":"Bermuda","continent_code":"NA"},
    "BT": {"name":"Bhutan","continent_code":"AS"},
    "BO": {"name":"Bolivia","continent_code":"SA"},
    "BQ": {"name":"Bonaire, Sint Eustatius and Saba","continent_code":"NA"},
    "BA": {"name":"Bosnia and Herzegovina","continent_code":"EU"},
    "BW": {"name":"Botswana","continent_code":"AF"},
    "BV": {"name":"Bouvet Island","continent_code":"AN"},
    "BR": {"name":"Brazil","continent_code":"SA"},
    "IO": {"name":"British Indian Ocean Territory","continent_code":"AS"},
    "BN": {"name":"Brunei Darussalam","continent_code":"AS"},
    "BG": {"name":"Bulgaria","continent_code":"EU"},
    "BF": {"name":"Burkina Faso","continent_code":"AF"},
    "BI": {"name":"Burundi","continent_code":"AF"},
    "KH": {"name":"Cambodia","continent_code":"AS"},
    "CM": {"name":"Cameroon","continent_code":"AF"},
    "CA": {"name":"Canada","continent_code":"NA"},
    "CV": {"name":"Cape Verde","continent_code":"AF"},
    "KY": {"name":"Cayman Islands","continent_code":"NA"},
    "CF": {"name":"Central African Republic","continent_code":"AF"},
    "TD": {"name":"Chad","continent_code":"AF"},
    "CL": {"name":"Chile","continent_code":"SA"},
    "CN": {"name":"China","continent_code":"AS"},
    "CX": {"name":"Christmas Island","continent_code":"AS"},
    "CC": {"name":"Cocos (Keeling) Islands","continent_code":"AS"},
    "CO": {"name":"Colombia","continent_code":"SA"},
    "KM": {"name":"Comoros","continent_code":"AF"},
    "CG": {"name":"Congo","continent_code":"AF"},
    "CD": {"name":"Congo, Democratic Republic of the Congo","continent_code":"AF"},
    "CK": {"name":"Cook Islands","continent_code":"OC"},
    "CR": {"name":"Costa Rica","continent_code":"NA"},
    "CI": {"name":"Cote D'Ivoire","continent_code":"AF"},
    "HR": {"name":"Croatia","continent_code":"EU"},
    "CU": {"name":"Cuba","continent_code":"NA"},
    "CW": {"name":"Curacao","continent_code":"NA"},
    "CY": {"name":"Cyprus","continent_code":"AS"},
    "CZ": {"name":"Czech Republic","continent_code":"EU"},
    "DK": {"name":"Denmark","continent_code":"EU"},
    "DJ": {"name":"Djibouti","continent_code":"AF"},
    "DM": {"name":"Dominica","continent_code":"NA"},
    "DO": {"name":"Dominican Republic","continent_code":"NA"},
    "EC": {"name":"Ecuador","continent_code":"SA"},
    "EG": {"name":"Egypt","continent_code":"AF"},
    "SV": {"name":"El Salvador","continent_code":"NA"},
    "GQ": {"name":"Equatorial Guinea","continent_code":"AF"},
    "ER": {"name":"Eritrea","continent_code":"AF"},
    "EE": {"name":"Estonia","continent_code":"EU"},
    "ET": {"name":"Ethiopia","continent_code":"AF"},
    "FK": {"name":"Falkland Islands (Malvinas)","continent_code":"SA"},
    "FO": {"name":"Faroe Islands","continent_code":"EU"},
    "FJ": {"name":"Fiji","continent_code":"OC"},
    "FI": {"name":"Finland","continent_code":"EU"},
    "FR": {"name":"France","continent_code":"EU"},
    "GF": {"name":"French Guiana","continent_code":"SA"},
    "PF": {"name":"French Polynesia","continent_code":"OC"},
    "TF": {"name":"French Southern Territories","continent_code":"AN"},
    "GA": {"name":"Gabon","continent_code":"AF"},
    "GM": {"name":"Gambia","continent_code":"AF"},
    "GE": {"name":"Georgia","continent_code":"AS"},
    "DE": {"name":"Germany","continent_code":"EU"},
    "GH": {"name":"Ghana","continent_code":"AF"},
    "GI": {"name":"Gibraltar","continent_code":"EU"},
    "GR": {"name":"Greece","continent_code":"EU"},
    "GL": {"name":"Greenland","continent_code":"NA"},
    "GD": {"name":"Grenada","continent_code":"NA"},
    "GP": {"name":"Guadeloupe","continent_code":"NA"},
    "GU": {"name":"Guam","continent_code":"OC"},
    "GT": {"name":"Guatemala","continent_code":"NA"},
    "GG": {"name":"Guernsey","continent_code":"EU"},
    "GN": {"name":"Guinea","continent_code":"AF"},
    "GW": {"name":"Guinea-Bissau","continent_code":"AF"},
    "GY": {"name":"Guyana","continent_code":"SA"},
    "HT": {"name":"Haiti","continent_code":"NA"},
    "HM": {"name":"Heard Island and Mcdonald Islands","continent_code":"AN"},
    "VA": {"name":"Holy See (Vatican City State)","continent_code":"EU"},
    "HN": {"name":"Honduras","continent_code":"NA"},
    "HK": {"name":"Hong Kong","continent_code":"AS"},
    "HU": {"name":"Hungary","continent_code":"EU"},
    "IS": {"name":"Iceland","continent_code":"EU"},
    "IN": {"name":"India","continent_code":"AS"},
    "ID": {"name":"Indonesia","continent_code":"AS"},
    "IR": {"name":"Iran, Islamic Republic of","continent_code":"AS"},
    "IQ": {"name":"Iraq","continent_code":"AS"},
    "IE": {"name":"Ireland","continent_code":"EU"},
    "IM": {"name":"Isle of Man","continent_code":"EU"},
    "IL": {"name":"Israel","continent_code":"AS"},
    "IT": {"name":"Italy","continent_code":"EU"},
    "JM": {"name":"Jamaica","continent_code":"NA"},
    "JP": {"name":"Japan","continent_code":"AS"},
    "JE": {"name":"Jersey","continent_code":"EU"},
    "JO": {"name":"Jordan","continent_code":"AS"},
    "KZ": {"name":"Kazakhstan","continent_code":"AS"},
    "KE": {"name":"Kenya","continent_code":"AF"},
    "KI": {"name":"Kiribati","continent_code":"OC"},
    "KP": {"name":"Korea, Democratic People's Republic of","continent_code":"AS"},
    "KR": {"name":"Korea, Republic of","continent_code":"AS"},
    "XK": {"name":"Kosovo","continent_code":"EU"},
    "KW": {"name":"Kuwait","continent_code":"AS"},
    "KG": {"name":"Kyrgyzstan","continent_code":"AS"},
    "LA": {"name":"Lao People's Democratic Republic","continent_code":"AS"},
    "LV": {"name":"Latvia","continent_code":"EU"},
    "LB": {"name":"Lebanon","continent_code":"AS"},
    "LS": {"name":"Lesotho","continent_code":"AF"},
    "LR": {"name":"Liberia","continent_code":"AF"},
    "LY": {"name":"Libyan Arab Jamahiriya","continent_code":"AF"},
    "LI": {"name":"Liechtenstein","continent_code":"EU"},
    "LT": {"name":"Lithuania","continent_code":"EU"},
    "LU": {"name":"Luxembourg","continent_code":"EU"},
    "MO": {"name":"Macao","continent_code":"AS"},
    "MK": {"name":"Macedonia, the Former Yugoslav Republic of","continent_code":"EU"},
    "MG": {"name":"Madagascar","continent_code":"AF"},
    "MW": {"name":"Malawi","continent_code":"AF"},
    "MY": {"name":"Malaysia","continent_code":"AS"},
    "MV": {"name":"Maldives","continent_code":"AS"},
    "ML": {"name":"Mali","continent_code":"AF"},
    "MT": {"name":"Malta","continent_code":"EU"},
    "MH": {"name":"Marshall Islands","continent_code":"OC"},
    "MQ": {"name":"Martinique","continent_code":"NA"},
    "MR": {"name":"Mauritania","continent_code":"AF"},
    "MU": {"name":"Mauritius","continent_code":"AF"},
    "YT": {"name":"Mayotte","continent_code":"AF"},
    "MX": {"name":"Mexico","continent_code":"NA"},
    "FM": {"name":"Micronesia, Federated States of","continent_code":"OC"},
    "MD": {"name":"Moldova, Republic of","continent_code":"EU"},
    "MC": {"name":"Monaco","continent_code":"EU"},
    "MN": {"name":"Mongolia","continent_code":"AS"},
    "ME": {"name":"Montenegro","continent_code":"EU"},
    "MS": {"name":"Montserrat","continent_code":"NA"},
    "MA": {"name":"Morocco","continent_code":"AF"},
    "MZ": {"name":"Mozambique","continent_code":"AF"},
    "MM": {"name":"Myanmar","continent_code":"AS"},
    "NA": {"name":"Namibia","continent_code":"AF"},
    "NR": {"name":"Nauru","continent_code":"OC"},
    "NP": {"name":"Nepal","continent_code":"AS"},
    "NL": {"name":"Netherlands","continent_code":"EU"},
    "AN": {"name":"Netherlands Antilles","continent_code":"NA"},
    "NC": {"name":"New Caledonia","continent_code":"OC"},
    "NZ": {"name":"New Zealand","continent_code":"OC"},
    "NI": {"name":"Nicaragua","continent_code":"NA"},
    "NE": {"name":"Niger","continent_code":"AF"},
    "NG": {"name":"Nigeria","continent_code":"AF"},
    "NU": {"name":"Niue","continent_code":"OC"},
    "NF": {"name":"Norfolk Island","continent_code":"OC"},
    "MP": {"name":"Northern Mariana Islands","continent_code":"OC"},
    "NO": {"name":"Norway","continent_code":"EU"},
    "OM": {"name":"Oman","continent_code":"AS"},
    "PK": {"name":"Pakistan","continent_code":"AS"},
    "PW": {"name":"Palau","continent_code":"OC"},
    "PS": {"name":"Palestinian Territory, Occupied","continent_code":"AS"},
    "PA": {"name":"Panama","continent_code":"NA"},
    "PG": {"name":"Papua New Guinea","continent_code":"OC"},
    "PY": {"name":"Paraguay","continent_code":"SA"},
    "PE": {"name":"Peru","continent_code":"SA"},
    "PH": {"name":"Philippines","continent_code":"AS"},
    "PN": {"name":"Pitcairn","continent_code":"OC"},
    "PL": {"name":"Poland","continent_code":"EU"},
    "PT": {"name":"Portugal","continent_code":"EU"},
    "PR": {"name":"Puerto Rico","continent_code":"NA"},
    "QA": {"name":"Qatar","continent_code":"AS"},
    "RE": {"name":"Reunion","continent_code":"AF"},
    "RO": {"name":"Romania","continent_code":"EU"},
    "RU": {"name":"Russia","continent_code":"AS"},
    "RW": {"name":"Rwanda","continent_code":"AF"},
    "BL": {"name":"Saint Barthelemy","continent_code":"NA"},
    "SH": {"name":"Saint Helena","continent_code":"AF"},
    "KN": {"name":"Saint Kitts and Nevis","continent_code":"NA"},
    "LC": {"name":"Saint Lucia","continent_code":"NA"},
    "MF": {"name":"Saint Martin","continent_code":"NA"},
    "PM": {"name":"Saint Pierre and Miquelon","continent_code":"NA"},
    "VC": {"name":"Saint Vincent and the Grenadines","continent_code":"NA"},
    "WS": {"name":"Samoa","continent_code":"OC"},
    "SM": {"name":"San Marino","continent_code":"EU"},
    "ST": {"name":"Sao Tome and Principe","continent_code":"AF"},
    "SA": {"name":"Saudi Arabia","continent_code":"AS"},
    "SN": {"name":"Senegal","continent_code":"AF"},
    "RS": {"name":"Serbia","continent_code":"EU"},
    "CS": {"name":"Serbia and Montenegro","continent_code":"EU"},
    "SC": {"name":"Seychelles","continent_code":"AF"},
    "SL": {"name":"Sierra Leone","continent_code":"AF"},
    "SG": {"name":"Singapore","continent_code":"AS"},
    "SX": {"name":"Sint Maarten","continent_code":"NA"},
    "SK": {"name":"Slovakia","continent_code":"EU"},
    "SI": {"name":"Slovenia","continent_code":"EU"},
    "SB": {"name":"Solomon Islands","continent_code":"OC"},
    "SO": {"name":"Somalia","continent_code":"AF"},
    "ZA": {"name":"South Africa","continent_code":"AF"},
    "GS": {"name":"South Georgia and the South Sandwich Islands","continent_code":"AN"},
    "SS": {"name":"South Sudan","continent_code":"AF"},
    "ES": {"name":"Spain","continent_code":"EU"},
    "LK": {"name":"Sri Lanka","continent_code":"AS"},
    "SD": {"name":"Sudan","continent_code":"AF"},
    "SR": {"name":"Suriname","continent_code":"SA"},
    "SJ": {"name":"Svalbard and Jan Mayen","continent_code":"EU"},
    "SZ": {"name":"Swaziland","continent_code":"AF"},
    "SE": {"name":"Sweden","continent_code":"EU"},
    "CH": {"name":"Switzerland","continent_code":"EU-FALSE"},
    "SY": {"name":"Syrian Arab Republic","continent_code":"AS"},
    "TW": {"name":"Taiwan, Province of China","continent_code":"AS"},
    "TJ": {"name":"Tajikistan","continent_code":"AS"},
    "TZ": {"name":"Tanzania, United Republic Of","continent_code":"AF"},
    "TH": {"name":"Thailand","continent_code":"AS"},
    "TL": {"name":"Timor-Leste","continent_code":"AS"},
    "TG": {"name":"Togo","continent_code":"AF"},
    "TK": {"name":"Tokelau","continent_code":"OC"},
    "TO": {"name":"Tonga","continent_code":"OC"},
    "TT": {"name":"Trinidad and Tobago","continent_code":"NA"},
    "TN": {"name":"Tunisia","continent_code":"AF"},
    "TR": {"name":"Turkey","continent_code":"AS"},
    "TM": {"name":"Turkmenistan","continent_code":"AS"},
    "TC": {"name":"Turks and Caicos Islands","continent_code":"NA"},
    "TV": {"name":"Tuvalu","continent_code":"OC"},
    "UG": {"name":"Uganda","continent_code":"AF"},
    "UA": {"name":"Ukraine","continent_code":"EU"},
    "AE": {"name":"United Arab Emirates","continent_code":"AS"},
    "GB": {"name":"United Kingdom","continent_code":"EU"},
    "US": {"name":"United States","continent_code":"NA"},
    "UM": {"name":"United States Minor Outlying Islands","continent_code":"NA"},
    "UY": {"name":"Uruguay","continent_code":"SA"},
    "UZ": {"name":"Uzbekistan","continent_code":"AS"},
    "VU": {"name":"Vanuatu","continent_code":"OC"},
    "VE": {"name":"Venezuela","continent_code":"SA"},
    "VN": {"name":"Viet Nam","continent_code":"AS"},
    "VG": {"name":"Virgin Islands, British","continent_code":"NA"},
    "VI": {"name":"Virgin Islands, U.s.","continent_code":"NA"},
    "WF": {"name":"Wallis and Futuna","continent_code":"OC"},
    "EH": {"name":"Western Sahara","continent_code":"AF"},
    "YE": {"name":"Yemen","continent_code":"AS"},
    "ZM": {"name":"Zambia","continent_code":"AF"},
    "ZW": {"name":"Zimbabwe","continent_code":"AF"}
};

class ShippingPopup extends HTMLElement {
    constructor() {
      super();
   
      this.initEventListener();
      this.checkUserLocation();

    }

    initEventListener() {
        this.querySelector('#shipping-popup-close').addEventListener('click', this.closePopup.bind(this));
        this.querySelector('[shipping-popup-close]').addEventListener('click', this.closePopup.bind(this));
        this.querySelector('#shipping-popup-submit').addEventListener('click', this.saveShippingCountry.bind(this));
        document.querySelectorAll('.footer-bottom__delivery .shipping-selector-countries').forEach((item) => {
           item.addEventListener('change', this.saveShippingCountryFooter.bind(this)); 
        });
    }

    checkUserLocation() {
        var that = this;
        fetch('https://ipapi.co/json').then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                console.log("Error IP LOCATOR 100");
            }
        })
        .then((response) => {
            var already_showed = document.getElementById('tva-rate').value.length > 0 ? true : false;
            console.log(response);
            if (response.continent_code != "EU") {
                setTimeout(function() {
                    if (!already_showed) {
                        that.openPopup();
                    }
                }, 15000);
            }
        })
        .catch((error) => {
            console.log("Error IP LOCATOR 101");
        });


    }

    closePopup() {
        this.closest('#section-v2-shipping-country-popup').classList.remove('open');
    }

    openPopup() {
        this.closest('#section-v2-shipping-country-popup').classList.add('open');
    }

    saveShippingCountry() {

        var country = this.querySelector('[name="country"]').value;
        console.log(country);

        var has_taxes = this.getTaxesArea(country) == "EU" ? true : false;

        //
        // ADD CART PROPERTIES TO ADD TAXES
        //

        var tax_value = has_taxes ? 20 : 0;
        var url = window.Shopify.routes.root + 'cart/update.js';
        var body =  "attributes[_tax-rate]=" + tax_value + "&attributes[_shipping-country]=" + country;
        fetch(url, {
            method: 'post',
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: body,
        })
        .then((response) => {
            console.dir(response);
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);
            console.dir(parsedState);
            window.location.reload();
            
        }).catch((error) => {
            //ERROR
            alert("Error : Shipping update error. If you see this error please contact us.\n" + error);
        });


    }

    saveShippingCountryFooter(event) {
        var e = event.target;
        var country = e.value;
        console.log(country);

        var has_taxes = this.getTaxesArea(country) == "EU" ? true : false;

        //
        // ADD CART PROPERTIES TO ADD TAXES
        //

        var tax_value = has_taxes ? 20 : 0;
        var url = window.Shopify.routes.root + 'cart/update.js';
        var body =  "attributes[_tax-rate]=" + tax_value + "&attributes[_shipping-country]=" + country;
        fetch(url, {
            method: 'post',
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: body,
        })
        .then((response) => {
            console.dir(response);
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);
            console.dir(parsedState);
            window.location.reload();
            
        }).catch((error) => {
            //ERROR
            console("Error : Shipping update error. If you see this error please contact us.\n" + error);
        });


    }

    getTaxesArea(country) {
        for (let c in countries) {
            if (countries[c].name == country) {
                return countries[c].continent_code;
            }
         }
    }
  
  }
  
  customElements.define('shipping-popup', ShippingPopup);
  